import styled from '@mui/styles/styled';

import SnackbarContent from '@mui/material/SnackbarContent';
import { red, green } from '@mui/material/colors';
import IconButton from '@mui/material/IconButton';
import { Styling, Colors } from '../../../constants';

export const SuccessSnackBar = styled(SnackbarContent)({
  backgroundColor: green[500],
  color: Colors.WHITE_100,
});

export const FailedSnackBar = styled(SnackbarContent)({
  backgroundColor: red[500],
  color: Colors.WHITE_100,
});

export const IconButtonWhite = styled(IconButton)({
  color: `${Colors.WHITE_100}`,
});
